import { ConfigModuleCategory } from 'library/ts/model/enums/config/ConfigModuleCategory';
import { IOmSdkParams } from 'tag/ts/tag/interfaces/config/omsdk/IOmSdkParams';

/**
 * @copyright © Paramount Streaming
 * @description OM SDK (OMID) ad verification plugin config for Pluto TV Blackbird.
 * Enabled by default for Stitcher playback — gated on `hasStitcherParams()` in `OmSdkPlugin.shouldBeUsed()`.
 * `serviceUrl`, `sessionClientUrl`, `loaderUrl`, and `partnerVersion` are resolved automatically at
 * runtime from `runtimeVO.url.root` and the Smart Tag release version if not set by the page.
 * `serviceUrl` + `sessionClientUrl` are the two-file path (web Service + Session Client) consumed by
 * Blackbird's loader; `loaderUrl` is the legacy concatenated single-file fallback.
 * @see {@link https://playback-docs.webctv.plutostaging.tv/docs/plugins/omsdk}
 */
export const TagConfigOmSdk = {
	category: ConfigModuleCategory.PLUGIN,
	enabled: true,
	params: {
		enabled: true,
		loaderUrl: null,
		serviceUrl: null,
		sessionClientUrl: null,
		partnerName: 'plutotv', // IAB-registered OMID partner name — confirmed by Khang Duong (Pluto TV Ads); not interchangeable with Partner.PTV
		partnerVersion: null
	} as IOmSdkParams
};